import React from 'react'
import request from 'superagent'
import {getColorStyle} from './Util'
import * as Categories from '../constants/Categories'
import {URL_DISEASE, URL_COVID} from '../constants/Url'
import {timeoutRedirect} from './Util'
import {Link} from "react-router-dom";
// import TagManager from 'react-gtm-module';
// import {getTagManagerArgs} from './Util';

export default class Disease extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      category_id: 2,
      category_name: '感染症',
      results: {},
      toggleRisklevel: null,
      loaded: false,
      covid_19_and_genetics: null
    }
  }

  handleToggleRisklevel(){
    if(this.state.toggleRisklevel === null){
      this.setState({toggleRisklevel: true})
    }else{
      this.setState({toggleRisklevel: !this.state.toggleRisklevel})
    }
  }

  handleClickOpen(unit_id){
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  handleClickClose(){
    const { handleModalClose } = this.props
    handleModalClose()
  }

  handleClickSwitchPage(page){
    if(this.props.toggleResult){
      this.props.toggleResultMethod()
    }
    this.props.switchPageMethod(page)
  }

  fetchData() {
    request
        .get(URL_COVID(this.props.access_token, this.props.gender, this.props.kit))
        .set('Content-Type', 'application/json')
        .end((err, res) => {
            if (err) {
                console.log('error')
            }
            if (!res || !res.body.result) {
                return;
            }
            const { covid_19_and_genetics } = res.body.result;
            this.setState({
              covid_19_and_genetics
            })
        })
  }

  selectCategory(category) {
    if(this.state.loaded){
      this.setState({loaded: false});
    }
    let _results = this.state.results;
    if(!_results[category.name] || 0 === _results[category.name].length) {
      request
        .get(URL_DISEASE(this.props.access_token, this.props.gender, this.props.kit, category.categories))
        .set('Content-Type', 'application/json')
        .end((err, res) => {
          if (err) {
            console.log('error')
            timeoutRedirect()
          }

          if (!res.body.result) {
            timeoutRedirect()
          }

          _results[category.name] = res.body.result
          this.setState({
            toggleRisklevel: null,
            results: _results,
            category: category.categories,
            category_id: category.id,
            category_name: category.name,
            loaded: true
          })
        })
    } else {
      this.setState({
        toggleRisklevel: null,
        results: this.state.results,
        category: category.categories,
        category_id: category.id,
        category_name: category.name,
        loaded: true
      })
    }
  }


  componentWillMount() {
    if (this.props.special_kit_codes.indexOf('genesis2_early') == -1) {
      this.fetchData();
    }
    this.selectCategory({id: 2, name: '感染症', categories: Categories.DiseaseInfections});
  }

  componentDidMount() {
  }

  render() {
    // TagManager.initialize(getTagManagerArgs('/disease/' + this.state.category_id));

    if(this.state.toggleRisklevel === true){
      this.state.results.sort(function(a,b){
        if(a.level_type<b.level_type) return 1;
        if(a.level_type > b.level_type) return -1;
        return 0;
      });
    }else if(this.state.toggleRisklevel === false){
      this.state.results.sort(function(a,b){
        if(a.level_type<b.level_type) return -1;
        if(a.level_type > b.level_type) return 0;
        return 0;
      });
    }

    if(!this.state.loaded){
      return (
      <div className="wrap">

        <div className="titlearea">
          <h2>疾患カテゴリ一覧</h2>
          {/*<p className="printbtn">印刷する</p>*/}
        </div>

        <div className="category_icon">
          <ul>
            {categories.map(c =>
              (
                <li key={c.id} className={this.state.category_id === c.id ? "active" : ""}>
                  <p className="icon" onClick={this.selectCategory.bind(this, c)}><img src={c.icon} alt={c.name}/><span>{c.name}</span></p>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="summary_table">
          <div className="inddata">
            <img style={{display: "block", margin: "auto"}} src="./image/loading.gif"/>
          </div>
        </div>

      </div>
        )
    }
    return (
      <div className="wrap">

        <div className="titlearea">
          <h2>疾患カテゴリ一覧</h2>
          {/*<p className="printbtn">印刷する</p>*/}
        </div>

        <div className="category_icon">
          <ul>
            {categories.map(c =>
              (
                <li key={c.id} className={this.state.category_id === c.id ? "active" : ""}>
                  <p className="icon" onClick={this.selectCategory.bind(this, c)}><img src={c.icon} alt={c.name}/><span>{c.name}</span></p>
                </li>
              )
            )}
          </ul>
        </div>

        <div className="summary_table">
          <div className="inddata">
            <table>
              <thead>
                <tr>
                  <th scope="col">検査項目</th>
                  <th scope="col" className="updown">結果</th>
                  <th scope="col">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
              {(this.state.results[this.state.category_name] || []).filter(data => data.unit.id !== 1022 ).map(data =>
                <tr key={data.unit.id}>
                  <td className="name">{data.unit.name}</td>
                  <td className={`riskrevel ${getColorStyle(data.level_type)}`}>{data.markup_level_name}</td>
                  <td className="detail">
                    <Link to={{
                      pathname: "/detail",
                      state: { referer: "/disease" }
                    }} ><div className="show_detail" onClick={this.handleClickOpen.bind(this, data.unit.id)}>詳細を見る</div></Link>
                  </td>
                </tr>
              )}
              {((this.props.special_kit_codes.indexOf('genesis2_early') == -1) && (this.state.category_id === 1 || this.state.category_id === 2) && this.state.covid_19_and_genetics && !!Object.keys(this.state.covid_19_and_genetics).length) ? (
                <tr key="1022">
                  <td className="name">COVID-19のレポート</td>
                  <td className={`riskrevel`}>{this.state.covid_19_and_genetics.markup_level_name}</td>
                  <td className="detail">
                  <Link to={{
                  pathname: "/covid19",
                  state: { referer: "/disease" }
                }} onClick={this.handleClickSwitchPage.bind(this, "Covid19")}><div className="show_detail">詳細を見る</div></Link>
                  </td>
                </tr>
              ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}
const categories = [
  {id: 2, icon: 'image/icon/2.png', name: '感染症', categories: Categories.DiseaseInfections},
  {id: 3, icon: 'image/icon/3.png', name: '性別', categories: Categories.DiseaseGender},
  {id: 4, icon: 'image/icon/4.png', name: '循環器', categories: Categories.DiseaseCirculatory},
  {id: 5, icon: 'image/icon/5.png', name: '呼吸器', categories: Categories.DiseaseRespiratory},
  {id: 6, icon: 'image/icon/6.png', name: '消化器', categories: Categories.DiseaseDigestive},
  {id: 7, icon: 'image/icon/7.png', name: '神経系', categories: Categories.DiseaseNeurological},
  {id: 8, icon: 'image/icon/8.png', name: '内分泌', categories: Categories.DiseaseEndocrineGlands},
  {id: 9, icon: 'image/icon/9.png', name: '泌尿器', categories: Categories.DiseaseUrinary},
  {id: 10, icon: 'image/icon/10.png', name: '骨・関節・皮膚', categories: Categories.DiseaseOsteoSkin},
  {id: 11, icon: 'image/icon/11.png', name: '血液・免疫', categories: Categories.DiseasebloodImmunity},
  {id: 12, icon: 'image/icon/12.png', name: '目・耳・鼻・口', categories: Categories.DiseaseEyeEarNoseOral},
  {id: 13, icon: 'image/icon/13.png', name: 'その他', categories: Categories.DiseaseOthers},
  {id: 1, icon: 'image/icon/1.png', name: '全て', categories: Categories.DiseaseAll},
];




// WEBPACK FOOTER //
// ./src/components/Disease.js